export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "96%", sm: "88%", md: "80%" },
  maxWidth: 900,
  bgcolor: "#111",
  color: "white",
  border: "1px solid rgba(255,255,255,0.08)",
  boxShadow: "0 24px 80px rgba(0,0,0,0.85)",
  borderRadius: "12px",
  maxHeight: { xs: "95vh", sm: "92vh" },
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const darkFieldSx = {
  "& .MuiInputBase-root": { color: "rgba(255,255,255,0.9)" },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.45)" },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "rgba(255,255,255,0.15)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
    "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,0.6)" },
    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
      WebkitBoxShadow: "0 0 0 100px #111 inset",
      WebkitTextFillColor: "rgba(255,255,255,0.9)",
      caretColor: "white",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: "rgba(255,255,255,0.8)" },
  "& input::-webkit-calendar-picker-indicator": {
    filter: "invert(1)",
    cursor: "pointer",
    opacity: 0.7,
    "&:hover": { opacity: 1 },
  },
};

export const chipSx = {
  backgroundColor: "transparent",
  border: "1px solid rgba(255,255,255,0.14)",
  color: "rgba(255,255,255,0.72)",
  height: 28,
  fontSize: "0.75rem",
  "& .MuiChip-label": { px: 1.2 },
  "& .MuiChip-deleteIcon": {
    color: "rgba(255,255,255,0.22)",
    fontSize: "0.9rem",
    "&:hover": { color: "rgba(255,255,255,0.6)" },
  },
};

// Row style for URL-type items (recordings, soundcloud links)
export const linkRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  py: 0.9,
  px: 1.5,
  borderRadius: "6px",
  backgroundColor: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.06)",
};

export const addBtnSx = {
  borderColor: "rgba(255,255,255,0.2)",
  color: "rgba(255,255,255,0.7)",
  height: "56px",
  "&:hover": {
    borderColor: "rgba(255,255,255,0.5)",
    backgroundColor: "rgba(255,255,255,0.05)",
    color: "white",
  },
};

export const imageStyle = {
  objectFit: "cover",
  width: "150px",
  height: "150px",
  borderRadius: "8px",
  marginBottom: "12px",
  cursor: "pointer",
  display: "block",
};

// ── Drag & drop list ──────────────────────────────────────────────────────────

export const dragListSx = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "100%",
};

export const dragItemSx = {
  borderRadius: "10px",
  backgroundColor: "#0e0e0e",
  border: "1px solid rgba(255,255,255,0.07)",
  overflow: "hidden",
  width: "100%",
  minWidth: 0,
};

export const dragRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 0.75,
  px: 1.5,
  background: "rgba(255,255,255,0.03)",
};

export const dragHandleSx = {
  fontSize: "15px",
  color: "rgba(255,255,255,0.2)",
  flexShrink: 0,
};

export const dragIndexSx = {
  color: "rgba(255,255,255,0.2)",
  fontSize: "0.6rem",
  flexShrink: 0,
  minWidth: 12,
};

export const dragTitleSx = {
  fontSize: "0.72rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1,
};

export const dragUrlSx = {
  color: "rgba(255,255,255,0.3)",
  fontSize: "0.68rem",
  flex: 1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const dragDeleteBtnSx = {
  color: "rgba(255,255,255,0.18)",
  p: "3px",
  flexShrink: 0,
  "&:hover": { color: "rgba(220,60,60,0.8)", backgroundColor: "rgba(255,60,60,0.07)" },
};

export const iframeWrapSx = {
  position: "relative",
  "& iframe": { display: "block", border: "none" },
};

export const iframeOverlaySx = {
  position: "absolute",
  inset: 0,
  zIndex: 1,
};
